import { Navigate } from "react-router-dom";
import { LoadingState } from "@/components/base/StateViews";
import { useAuth } from "@/contexts/AuthContext";
import DashboardHome from "@/pages/dashboard/page";
import { isNotesOnly } from "./navItems";

/** Page d'accueil : la vue d'ensemble, ou directement Notes pour un compte enseignant. */
export default function DashboardIndex() {
  const { can, loading } = useAuth();
  if (loading) return <LoadingState label="Vérification des accès..." />;
  return isNotesOnly(can) ? <Navigate to="/dashboard/grades" replace /> : <DashboardHome />;
}
